import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw, Zap, Clock } from 'lucide-react';

const CAT = { pop_culture: 'Pop culture', manga: 'Manga', theatre: 'Théâtre', world_cultures: 'Cultures & civilisations' };

// Admin › Cinéma › Pop culture : automatisation hebdomadaire (lundi 09:00 Cayenne)
const PopCultureAutoPanel = () => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const r = await axios.get('/api/admin/pop-culture/auto/status');
      setStatus(r.data);
    } catch (e) { /* silencieux */ }
  };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!status?.running) return undefined;
    const id = setInterval(load, 4000);
    return () => clearInterval(id);
  }, [status?.running]);

  const toggle = async () => {
    try {
      const r = await axios.post('/api/admin/pop-culture/auto/toggle', { enabled: !status.enabled });
      setStatus((s) => ({ ...s, enabled: r.data.enabled }));
      toast.success(r.data.enabled ? 'Automatisation activée' : 'Automatisation désactivée');
    } catch (e) { toast.error('Erreur'); }
  };
  const runNow = async () => {
    setBusy(true);
    try {
      await axios.post('/api/admin/pop-culture/auto/run');
      toast.success('Actualisation lancée — les nouvelles brèves arrivent dans 1 à 2 minutes');
      setStatus((s) => ({ ...s, running: true }));
      setTimeout(load, 3000);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); }
    finally { setBusy(false); }
  };

  if (!status) return null;
  const lr = status.last_run;
  return (
    <div className="rounded-xl border border-fuchsia-500/30 bg-fuchsia-500/5 p-3 space-y-2" data-testid="popculture-auto-panel">
      <div className="flex items-center gap-2">
        <Zap className="w-4 h-4 text-fuchsia-300" />
        <p className="text-sm font-semibold flex-1">Actualisation automatique hebdomadaire</p>
        <button
          onClick={toggle}
          className={`relative w-11 h-6 rounded-full transition-colors ${status.enabled ? 'bg-fuchsia-500' : 'bg-white/20'}`}
          data-testid="popculture-auto-toggle"
          aria-label="Activer l'automatisation"
        >
          <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${status.enabled ? 'translate-x-5' : 'translate-x-0'}`} />
        </button>
      </div>
      <p className="text-xs text-gray-400 flex items-center gap-1"><Clock className="w-3 h-3" /> {status.schedule} · {status.per_category} brèves par rubrique ({Object.values(CAT).join(', ')}) · traduites dans les 13 langues. L'ajout manuel reste possible.</p>
      <div className="flex items-center gap-2 flex-wrap text-xs">
        <button onClick={runNow} disabled={busy || status.running} className="px-3 py-1.5 rounded-lg bg-fuchsia-600 hover:bg-fuchsia-500 disabled:opacity-50 text-white font-semibold flex items-center gap-1" data-testid="popculture-auto-run">
          <RefreshCw className={`w-3.5 h-3.5 ${status.running ? 'animate-spin' : ''}`} /> {status.running ? 'En cours…' : 'Actualiser maintenant'}
        </button>
        <span className="text-gray-400" data-testid="popculture-auto-total">{status.total_auto_items} brèves auto au total</span>
        {lr && (
          <span className="text-gray-500" data-testid="popculture-auto-lastrun">
            Dernière : {lr.ran_at?.slice(0, 16).replace('T', ' ')} UTC · +{lr.added}
            {lr.errors?.length ? ` · ${lr.errors.length} erreur(s)` : ''}
          </span>
        )}
      </div>
    </div>
  );
};

export default PopCultureAutoPanel;
